import React from "react";
import Quote from "../../components/quote/quote.component";

const HomePage = () => {
  return <Quote />;
};

export default HomePage;
